import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useStores } from "../../hooks/useStores";

export const PrivateRoute: React.FC = () => {
  const { session } = useStores();

  return session.isAuthenticated ? <Outlet /> : <Navigate to="/logout" />;
};
